import(/* webpackMode: "eager" */ "/app/src/app/(consent-manger)/[locale]/(lagacy-footer)/professional-directory/claim/[id]/page.tsx");
